import type { ResourcesConfig } from "@aws-amplify/core"

import { UtilHelper } from "@front-shared/helpers/util.helper"

import { ROUTES_CONFIG } from "./routes.config"

export const AWS_CONFIG = {
    get amplify(): ResourcesConfig {
        return {
            Auth: {
                Cognito: {
                    userPoolId: import.meta.env.VITE_COGNITO_POOL_ID || "",
                    userPoolClientId:
                        import.meta.env.VITE_COGNITO_APP_CLIENT_ID || "",
                    loginWith: {
                        oauth: {
                            domain:
                                import.meta.env.VITE_COGNITO_APP_OAUTH_DOMAIN ||
                                "",
                            scopes: [
                                "email",
                                "profile",
                                "openid",
                                // Required for backend to call Cognito's getUser() API when using access tokens.
                                // Without this scope, the backend cannot retrieve user attributes from Cognito
                                // using the access token (e.g., for federated/SSO users where we use access tokens instead of ID tokens).
                                "aws.cognito.signin.user.admin",
                            ],
                            redirectSignIn: [
                                UtilHelper.getCurrentAppDomain() +
                                    ROUTES_CONFIG.authCallbackUrl,
                            ],
                            redirectSignOut: [
                                UtilHelper.getCurrentAppDomain() +
                                    ROUTES_CONFIG.logoutUrl,
                            ],
                            responseType: "code",
                        },
                    },
                },
            },
        }
    },
}
